// extracted by mini-css-extract-plugin
module.exports = {"title":"M_S","text":"M_Q","icon":"M_W","dates":"M_br","info":"M_bs","dividerAnimation":"M_p"};